<template>
	<div>Management.vue test</div>
</template>

<script type="text/javascript">
export default {
	name: 'Management',
}
</script>